var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad5" },
    [
      _c("app-divider", { attrs: { label: "Destinação e Uso do Imóvel" } }),
      _c("el-row", { staticClass: "pad5" }, [
        _c("p", [
          _c("span", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.montarDestinacaoDoImovel()))
          ])
        ])
      ]),
      _c(
        "el-row",
        { staticClass: "pad5" },
        [
          _c("p", [
            _c("span", { staticClass: "label" }, [
              _vm._v("Possui Reserva Legal?")
            ]),
            _c("span", { staticClass: "text" }, [
              _vm._v(
                "  " +
                  _vm._s(
                    _vm.getPossuiReservaLegal(
                      _vm.destinacaoUsoImovel.possuiReservaLegal
                    )
                  )
              )
            ])
          ]),
          _vm.destinacaoUsoImovel.possuiReservaLegal === "SIM"
            ? _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("Área:")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " +
                      _vm._s(
                        _vm.filterNull(_vm.destinacaoUsoImovel.areaReservaLegal)
                      )
                  )
                ])
              ])
            : _vm._e(),
          _vm.destinacaoUsoImovel.possuiReservaLegal === "SIM"
            ? _c("p", [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Percentual Utilizado:")
                ]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " +
                      _vm._s(
                        _vm.filterNull(
                          _vm.destinacaoUsoImovel.percentualAreaReservalegal
                        )
                      )
                  )
                ])
              ])
            : _vm._e(),
          _c("p", [
            _c("span", { staticClass: "label" }, [
              _vm._v("Possui comprovante de produtividade?")
            ]),
            _c("span", { staticClass: "text" }, [
              _vm._v(
                "  " +
                  _vm._s(
                    _vm.getPossuiComprovante(
                      _vm.destinacaoUsoImovel.produtividade.possuiComprovante
                    )
                  )
              )
            ])
          ]),
          _vm.destinacaoUsoImovel.produtividade.possuiComprovante
            ? _c("p", [
                _c("span", { staticClass: "label" }, [_vm._v("Tipo:")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " +
                      _vm._s(
                        _vm.getTipo(_vm.destinacaoUsoImovel.produtividade.tipo)
                      )
                  )
                ])
              ])
            : _vm._e(),
          _vm.destinacaoUsoImovel.produtividade.possuiComprovante &&
          _vm.destinacaoUsoImovel.produtividade.tipo !== "OUTROS"
            ? _c("p", [
                _c("span", { staticClass: "label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getLabel(_vm.destinacaoUsoImovel.produtividade.tipo)
                    )
                  )
                ]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    "  " +
                      _vm._s(
                        _vm.getNumero(_vm.destinacaoUsoImovel.produtividade)
                      )
                  )
                ])
              ])
            : _vm._e(),
          _vm.destinacaoUsoImovel.produtividade.possuiComprovante
            ? _c("app-resumo-documentos", {
                attrs: {
                  documentos: _vm.destinacaoUsoImovel.produtividade.documentos
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.temAtividade
        ? _c(
            "el-row",
            { staticClass: "pad5" },
            [
              _vm.destinacaoUsoImovel.culturasPermanentes.length
                ? _c("app-collapse", {
                    attrs: {
                      atividades: _vm.destinacaoUsoImovel.culturasPermanentes,
                      titulo: "Culturas Permanentes",
                      tipoAtividade: "CULTURA_PERMANENTE"
                    }
                  })
                : _vm._e(),
              _vm.destinacaoUsoImovel.culturasTemporarias.length
                ? _c("app-collapse", {
                    attrs: {
                      atividades: _vm.destinacaoUsoImovel.culturasTemporarias,
                      titulo: "Culturas Temporarias",
                      tipoAtividade: "CULTURA_TEMPORARIA"
                    }
                  })
                : _vm._e(),
              _vm.destinacaoUsoImovel.semoventes.length
                ? _c("app-collapse", {
                    attrs: {
                      atividades: _vm.destinacaoUsoImovel.semoventes,
                      titulo: "Semoventes",
                      tipoAtividade: "SEMOVENTES"
                    }
                  })
                : _vm._e(),
              _vm.destinacaoUsoImovel.edificacoes.length
                ? _c("app-collapse", {
                    attrs: {
                      atividades: _vm.destinacaoUsoImovel.edificacoes,
                      titulo: "Edificações",
                      tipoAtividade: "EDIFICACOES"
                    }
                  })
                : _vm._e(),
              _vm.destinacaoUsoImovel.outrasAtividades.length
                ? _c("app-collapse", {
                    attrs: {
                      atividades: _vm.destinacaoUsoImovel.outrasAtividades,
                      titulo: "Outras Atividades",
                      tipoAtividade: "OUTRAS_ATIVIDADES"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f5f2d7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f5f2d7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoDestinacaoUsoImovel.vue
// module id = null
// module chunks = 